import styled from 'styled-components';

const TextInput = styled.input`
  box-sizing: border-box;
  width: 100%;
  padding: 8px 15px;
  font-size: ${(props) => props.fontSize || '16px'};
  font-family: inherit;
  border: 1px solid #715aff;
  border-radius: 5px;
  outline: none;

  &:focus:not(:disabled) {
    box-shadow: 0 0 0.5px #715aff;
  }

  &:disabled {
    background-color: #f2f2f2;
  }
`;

export default TextInput;
